import React, { Component, PropTypes } from 'react';
import '../../../../styles/styles.scss';

export default class Spinner extends Component {
    static propTypes = {
        show: PropTypes.bool
    };

    render() {
        return (
            <div className="container_spinner">
                <div className="main_spinner" style={this.props.styles}></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/theme/buttons/Spinner.js